<template>
  <div>
    <header class="header">
      <el-row class="po-r w100 h100">
        <el-col class="po-r" :span="6">
          <router-link class="in-block font-0 header-logo" :to="{ name: 'home' }">
            <img :src="`${baseUrl}images/logo2.png`">
          </router-link>
        </el-col>

        <el-col class="tx-c" :span="12">
          <router-link class="in-block font-0 white header-link" :class="{ 'router-link-active': hasRouteName('home') }" :to="{ name: 'home' }">
            <span class="font-16">办事大厅</span>
          </router-link>
          <router-link class="in-block font-0 white header-link" :class="{ 'router-link-active': hasRouteName('serve') }" :to="{ name: 'serve' }">
            <span class="font-16">服务中心</span>
          </router-link>
          <!-- <router-link class="in-block font-0 white header-link" v-if="hasJur" :class="{ 'router-link-active': hasRouteName('about') }" :to="{ name: 'about' }">
            <span class="font-16">统计报表</span>
          </router-link> -->
          <router-link class="in-block font-0 white header-link" :class="{ 'router-link-active': hasRouteName('by') }" :to="{ path: '/serveCount' }">
            <span class="font-16">统计报表</span>
          </router-link>
          <!-- <router-link class="in-block font-0 white header-link" v-if="hasOffect" :class="{ 'router-link-active': $route.name == 'office' }" :to="{ name: 'office' }">
            <span class="font-16">管理中心</span>
          </router-link> -->
          <router-link class="in-block font-0 white header-link" :class="{ 'router-link-active': hasRouteName('office', 'server_my_office') }" :to="{ path: '/office' }">
            <span class="font-16">管理中心</span>
          </router-link>
        </el-col>

        <el-col class="po-r h100 white font-14 tx-r header-user" :span="5" v-loading="this.userLoading" element-loading-background="rgba(0, 0, 0, .5)">
          <section v-if="userData">
            <img class="mr5" :src="userData.userImg">
            {{ userData.userName }}
            <router-link class="ml10 white" :to="{ name: 'server_collect' }"><i class="mr5 el-icon-star-off"></i>我的收藏</router-link>
            <!-- <el-dropdown>
                <span class="white">
                    {{ userData.userName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <router-link class="in-block pt5 pb5 pl10 pr10" :to="{ name: 'server_collect' }">我的收藏</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <router-link class="in-block pt5 pb5 pl10 pr10" :to="{ name: 'sign' }">签名管理</router-link>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
            <span class="ml20 cu-p" @click="clickLogout()">退出</span>
          </section>
        </el-col>
      </el-row>
    </header>
    <div class="header-fix"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Header",
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    ...mapState(["userData", "userLoading", "routeJur"])
  },
  mounted() {},
  methods: {
    ...mapActions(["logout"]),
    clickLogout() {
      this.logout().then(() => {
        window.location.reload();
      });
    },
    hasRouteName(str, elseName) {
      // console.log(this.$route.name, str);
      return this.$route.name && this.$route.name.indexOf(str) > -1
        ? elseName && this.$route.name.indexOf(elseName) > -1
          ? false
          : true
        : false;
    }
  }
};
</script>

<style scoped>
.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 70px;
  background: #475eb7;
  z-index: 60;
}

.header-fix {
  width: 100%;
  height: 70px;
}

.header-logo {
  margin: 16px 0 0 20px;
  width: 353px;
  height: 37px;
}

.header-link {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
}

.header-link.router-link-active {
  background: #7085d7;
}

.search {
  margin: 19px auto 0 auto;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  background: #eeeeee 95% center no-repeat;
  background-size: 26px 26px;
  cursor: text;
}

.header-user {
  padding: 15px 0 0 0;
}

.header-user img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}
</style>
